var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlPayDepositIconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon example "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.38967 12.9556V2.03516H12.5896V12.9556H7.38967ZM1.42188 12.9556V2.03516H6.61354V12.9556H1.42188ZM2.57717 3.19876V11.8003H5.45825V3.19876H2.57717Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlPayDepositIconsvg);
export default __webpack_public_path__ + "static/media/bl-pay-deposit-icon.svg.da37871276f40d9696d10d81a1d4d503.svg";
export { ForwardRef as ReactComponent };